import React, { useEffect } from "react";
import PropTypes from "prop-types";
import TextInput from "../common/formfields/TextInput"

const SettingsGeneralForm = ({
    settings,
    onSave,
    onChange,
    processing = false,
    errors = {}
}) => {
    return (
        <form className="col-md-6 mt-md-5">
            <h2>Your Details</h2>
            <hr />
            {errors.onGeneralSave && (
                <div className="alert alert-danger" role="alert">
                    {errors.onGeneralSave}
                </div>
            )}

           <TextInput
                name="firstName"
                label="First Name"
                type="text"
                value={settings.firstName}
                onChange={onChange}
                error={errors.firstName}
            />
            <TextInput
                name="surname"
                label="Surname"
                type="text"
                value={settings.surname}
                onChange={onChange}
                error={errors.surname}
            />
            <TextInput
                name="email"
                label="Email Address"
                type="email"
                value={settings.email}
                onChange={onChange}
                error={errors.email}
            />
            <TextInput
                name="location"
                label="Location"
                type="text"
                value={settings.location}
                onChange={onChange}
                error={errors.location}
            />
           


            <button type="submit" onClick={onSave} disabled={processing} className="btn btn-primary float-right">
                {processing ? "Processing..." : "Save Changes"}
            </button>
        </form>



    );
}

SettingsGeneralForm.propTypes = {
    settings: PropTypes.object.isRequired,
    errors: PropTypes.object,
    onSave: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    processing: PropTypes.bool
}

export default SettingsGeneralForm;


// WEBPACK FOOTER //
// ./src/components/user/SettingsGeneralForm.js